import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ArrowRightLine} from '@dropbox/dig-icons/assets';
import {useState} from 'react';
import {Link, useLocation} from 'react-router';

import {viaState} from './workstreamsAnalytics';

/**
 * /workstreams: "All quarters →" beside a card's Metrics label (shown
 * with its edit pencil, on hover): the Metrics tab, where every quarter is a
 * column, instead of a per-card quarter picker. The same in-app switch as the
 * tab — this page with `view=metrics` — so no reload and the scope stays put.
 */
export const AllQuartersLink = () => {
  const location = useLocation();
  const [hovered, setHovered] = useState(false);
  const params = new URLSearchParams(location.search);
  params.set('view', 'metrics');
  return (
    <Link
      to={`${location.pathname}?${params.toString()}`}
      // On a focused card this is /workstreams/:id, which isn't its full page.
      data-own-link
      state={viaState('all_quarters')}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={atoms({color: 'inherit'})}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        marginLeft: 8,
        textDecoration: hovered ? 'underline' : 'none',
      }}
    >
      <Text size="small" color={hovered ? 'standard' : 'subtle'}>
        All quarters
      </Text>
      <UIIcon src={ArrowRightLine} size="small" className={atoms({color: 'Text Subtle'})} />
    </Link>
  );
};
